import React, { useCallback, useContext, useEffect } from "react";
import * as notify from "shared/notify";
import { AttributesContext } from "contexts/attributes";
import { useAttributeUpdate } from "components/attributes/hooks/use-attribute-update";

export const QAButtons = ({ roleLabels, attr, task, refetchCoderRoles, toggleQaEdit, hasRedo, disabled }) => {
    const { refresh } = useContext(AttributesContext);
    const { mutate: updateQaAttribute } = useAttributeUpdate();

    const confirmCoderChoice = async (r) => {
        const confirm = await notify.confirm(`Are you sure you want to accept the value from ${r.taskLabel} ${r.label} for ${attr.name}?`);

        if (!confirm) {
            return;
        }

        updateQaAttribute(
            {
                codingWipKey: task.context.codingWipKey,
                taskKey: task.key,
                sourcePage: task.sourcePage,
                payload: {
                    definition: attr.uuid,
                    value: r.attributes[attr.uuid],
                    type: attr.componentType,
                },
            },
            {
                onSuccess: (response) => {
                    if (response) {
                        notify.success("Attribute saved");
                        refetchCoderRoles();
                        refresh();
                    }
                },
            }
        );
    };

    return (
        <div
            key={`${attr.uuid}`}
            className="justify-content-center"
        >
            <div className="button-group -center -wrap -center-group">
                {roleLabels.map((r, index) => {
                    if (r.type !== "qa") {
                        return (
                            <button
                                key={`${attr.uuid}_${index}`}
                                className="button -primary -small flex-33"
                                onClick={() => confirmCoderChoice(r)}
                                disabled={hasRedo || disabled}
                            >
                                Accept {r.label}
                            </button>
                        );
                    } else {
                        return (
                            <button
                                key={`${attr.uuid}_${index}`}
                                className="button -primary -small flex-33"
                                onClick={toggleQaEdit}
                                disabled={hasRedo || disabled}
                            >
                                Override
                            </button>
                        );
                    }
                })}
            </div>
        </div>
    );
};
